import { INIT_AUTH, CLEAR_ACCESS_TOKEN, DONE_INITIALISING, SET_ADMIN_DISCOVERY_SET_ID, LOAD_ACCESS_TOKEN_SUCCESS, LOAD_ACCESS_TOKEN_FAILURE, SET_ANONYMOUS_INVITE_ID, SET_ANONYMOUS_FIRM_AND_ADVISER } from './constants'

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [INIT_AUTH]: (state, { isAdminArea }) => ({...state, isAdminArea}),
  //[LOAD_ACCESS_TOKEN_REQUEST]: (state, action) => ({ ...state, isLoading: true }),
  [CLEAR_ACCESS_TOKEN]: (state) => ({ ...state, accessToken: null }),
  [DONE_INITIALISING]: (state) => ({ ...state, isInitialising: false }),
  [SET_ANONYMOUS_INVITE_ID]: (state, { anonymousInviteId }) => ({ ...state, anonymousInviteId }),
  [SET_ANONYMOUS_FIRM_AND_ADVISER]: (state, { firmId, financialAdvisorId }) => ({...state, firmId, financialAdvisorId }),
  [LOAD_ACCESS_TOKEN_SUCCESS]: (state, { data }) => ({ ...state, accessToken: data.access_token }),
  [LOAD_ACCESS_TOKEN_FAILURE]: (state, action) => ({ ...state, accessToken: null }),
  [SET_ADMIN_DISCOVERY_SET_ID]: (state, {discoverySetId}) => ({ ...state, discoverySetId }),
}

export function localStorageStateSlicer({accessToken}) {
  return {
    accessToken
  }
}
// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
  isAdminArea: false,
  isInitialising: true,
  //isLoading: false,
  accessToken: null,
  discoverySetId: null
}
export default function authReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/modules/reducer.js
 **/